import { colors } from '../../constants';
const MuiCheckbox = {
  root: {
    color: colors.text.disabled
  }
};
export default MuiCheckbox;